// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ty-drawer-content[data-v-2358b1ac] {\n  width: 94%;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
